<div class="feature-notification">
    <div class="feature-notification__content">
        <div class="feature-notification__animation" aria-hidden="true">
            <svg viewBox="0 0 360 180" xmlns="http://www.w3.org/2000/svg" class="fn-svg">
                <defs>
                    <pattern id="fn-grid" x="0" y="0" width="18" height="18" patternUnits="userSpaceOnUse">
                        <circle cx="1" cy="1" r="1" fill="currentColor" opacity="0.12"></circle>
                    </pattern>
                    <linearGradient id="fn-bg" x1="0" y1="0" x2="1" y2="1">
                        <stop offset="0%" stop-color="#eef2ff" />
                        <stop offset="100%" stop-color="#f5f1ff" />
                    </linearGradient>
                    <clipPath id="fn-typing-clip">
                        <rect class="fn-typing-clip" x="32" y="142" width="0" height="24"></rect>
                    </clipPath>
                </defs>

                <rect class="fn-bg" width="360" height="180" rx="8" fill="url(#fn-bg)"></rect>
                <rect width="360" height="180" rx="8" fill="url(#fn-grid)"></rect>

                <!-- ============================================== -->
                <!-- ACT 1 (0–1.5s): "+ Create" button only          -->
                <!-- ============================================== -->
                <g class="fn-act fn-act--1">
                    <!-- Create button (dark) -->
                    <g class="fn-add-button">
                        <rect x="130" y="74" width="100" height="40" rx="20" fill="#1f2937"></rect>
                        <text x="180" y="100" text-anchor="middle" font-size="14" font-weight="500" fill="#fff" font-family="system-ui, sans-serif">+ Create</text>
                    </g>

                    <!-- Click ripple -->
                    <circle class="fn-click-ripple" cx="180" cy="93" r="0" fill="none" stroke="#6384ff" stroke-width="1.5"></circle>

                    <!-- Cursor for act 1 -->
                    <g class="fn-pointer-1">
                        <path d="M0 0 L0 14 L4 11 L7 17 L10 16 L7 9 L12 9 Z" fill="#1f2937" stroke="#fff" stroke-width="1"></path>
                    </g>
                </g>

                <!-- ============================================== -->
                <!-- ACT 2 (1.5–3.5s): chat with typed prompt        -->
                <!-- ============================================== -->
                <g class="fn-act fn-act--2">
                    <!-- Header -->
                    <text class="fn-chat-title fn-chat-title--initial" x="20" y="24" font-size="13" font-weight="600" fill="#1f2937" font-family="system-ui, sans-serif">New database</text>
                    <text class="fn-chat-title fn-chat-title--final" x="20" y="24" font-size="13" font-weight="600" fill="#1f2937" font-family="system-ui, sans-serif">Bookings for climbing gym</text>
                    <line class="fn-chat-divider" x1="20" y1="34" x2="340" y2="34" stroke="#e5e7eb" stroke-width="0.8"></line>

                    <!-- Input field -->
                    <g class="fn-input">
                        <rect x="20" y="136" width="320" height="30" rx="15" fill="#fff" stroke="#d6dcff" stroke-width="1"></rect>
                        <g clip-path="url(#fn-typing-clip)">
                            <text x="34" y="158" font-size="16" fill="#1f2937" font-family="ui-monospace, SFMono-Regular, monospace">Bookings for climbing gym</text>
                        </g>
                        <rect class="fn-caret" x="34" y="144" width="1.6" height="18" fill="#1f2937"></rect>
                        <!-- Send button -->
                        <g class="fn-send-button">
                            <circle cx="326" cy="151" r="11" fill="#6384ff"></circle>
                            <path d="M321 154 L326 147 L331 154 M326 147 L326 159" stroke="#fff" stroke-width="1.5" fill="none" stroke-linecap="round" stroke-linejoin="round"></path>
                        </g>
                    </g>

                </g>

                <!-- ============================================== -->
                <!-- ACT 3 (3.5–5.5s): AI reply with diagram         -->
                <!-- ============================================== -->
                <g class="fn-act fn-act--3">
                    <!-- AI avatar (lifted above the diagram) -->
                    <g class="fn-ai-avatar">
                        <circle cx="22" cy="50" r="10" fill="#eef2ff"></circle>
                        <path d="M22 43.5 L23.4 47.6 L27.5 49 L23.4 50.4 L22 54.5 L20.6 50.4 L16.5 49 L20.6 47.6 Z" fill="#6384ff"></path>
                    </g>

                    <!-- Mini diagram (3 tables) -->
                    <g class="fn-table fn-table--1">
                        <rect x="18" y="74" width="102" height="66" rx="7" fill="#fff" stroke="#c4cdff" stroke-width="1.2"></rect>
                        <rect x="18" y="74" width="102" height="18" rx="7" fill="#c4b5fd"></rect>
                        <text x="28" y="87" font-size="12" font-weight="600" fill="#fff" font-family="system-ui, sans-serif">members</text>
                        <text x="28" y="106" font-size="10" fill="#445" font-family="system-ui, sans-serif">id</text>
                        <text x="112" y="106" font-size="8" font-weight="700" fill="#b45309" font-family="system-ui, sans-serif" text-anchor="end">PK</text>
                        <text x="28" y="120" font-size="10" fill="#445" font-family="system-ui, sans-serif">name</text>
                        <text x="28" y="134" font-size="10" fill="#445" font-family="system-ui, sans-serif">email</text>
                    </g>

                    <g class="fn-table fn-table--2">
                        <rect x="130" y="58" width="102" height="66" rx="7" fill="#fff" stroke="#c4cdff" stroke-width="1.2"></rect>
                        <rect x="130" y="58" width="102" height="18" rx="7" fill="#93c5fd"></rect>
                        <text x="140" y="71" font-size="12" font-weight="600" fill="#fff" font-family="system-ui, sans-serif">bookings</text>
                        <text x="140" y="90" font-size="10" fill="#445" font-family="system-ui, sans-serif">id</text>
                        <text x="224" y="90" font-size="8" font-weight="700" fill="#b45309" font-family="system-ui, sans-serif" text-anchor="end">PK</text>
                        <text x="140" y="104" font-size="10" fill="#445" font-family="system-ui, sans-serif">member_id</text>
                        <text x="224" y="104" font-size="8" font-weight="700" fill="#2563eb" font-family="system-ui, sans-serif" text-anchor="end">FK</text>
                        <text x="140" y="118" font-size="10" fill="#445" font-family="system-ui, sans-serif">date</text>
                    </g>

                    <g class="fn-table fn-table--3">
                        <rect x="242" y="78" width="102" height="62" rx="7" fill="#fff" stroke="#c4cdff" stroke-width="1.2"></rect>
                        <rect x="242" y="78" width="102" height="18" rx="7" fill="#fbcfe8"></rect>
                        <text x="252" y="91" font-size="12" font-weight="600" fill="#fff" font-family="system-ui, sans-serif">sessions</text>
                        <text x="252" y="110" font-size="10" fill="#445" font-family="system-ui, sans-serif">id</text>
                        <text x="336" y="110" font-size="8" font-weight="700" fill="#b45309" font-family="system-ui, sans-serif" text-anchor="end">PK</text>
                        <text x="252" y="124" font-size="10" fill="#445" font-family="system-ui, sans-serif">starts_at</text>
                    </g>

                    <!-- Relations -->
                    <path class="fn-link fn-link--1" d="M 120 106 C 125 106 125 90 130 90" stroke="#c4b5fd" stroke-width="1.6" fill="none" stroke-linecap="round"></path>
                    <path class="fn-link fn-link--2" d="M 232 90 C 237 90 237 110 242 110" stroke="#93c5fd" stroke-width="1.6" fill="none" stroke-linecap="round"></path>

                    <!-- "Schema ready ✓" -->
                    <g class="fn-schema-ready">
                        <text x="180" y="162" text-anchor="middle" font-size="12" font-weight="600" fill="#10b981" font-family="system-ui, sans-serif">Schema ready ✓</text>
                    </g>
                </g>
            </svg>
        </div>
        <h1 class="feature-notification__title">Design schemas with AI</h1>
        <p class="feature-notification__description">
            Generate a new database from scratch or edit your existing one — just describe what you need.
        </p>
    </div>
    <div class="actions">
        <button type="button" mat-flat-button color="accent" class="actions__primary" (click)="dismiss.emit()">
            Got it
        </button>
    </div>
</div>
